import { render, staticRenderFns } from "./FormulasTable.vue?vue&type=template&id=52cce152&scoped=true"
import script from "./FormulasTable.vue?vue&type=script&lang=js"
export * from "./FormulasTable.vue?vue&type=script&lang=js"
import style0 from "./FormulasTable.vue?vue&type=style&index=0&id=52cce152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cce152",
  null
  
)

export default component.exports